import { render, staticRenderFns } from "./TxRowActionBadge.vue?vue&type=template&id=141a3317"
import script from "./TxRowActionBadge.vue?vue&type=script&lang=js"
export * from "./TxRowActionBadge.vue?vue&type=script&lang=js"
import style0 from "./TxRowActionBadge.vue?vue&type=style&index=0&id=141a3317&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports